export default String.raw`
<rect width="1440" height="1048" class="bgColor"/>
<g id="Koszyk one page/Zalogowany">
    <g id="Frame 677">
        <g id="Frame 820">
            <g id="Naglowek_cart">
                <text id="Koszyk 1" class="primaryColorFont"   font-family="Inter" font-size="24" font-weight="500" letter-spacing="0px">
                    <tspan x="130.402" y="56.7273">TRANSLATION_Prv_Cart_Title</tspan>
                </text>
                <g id="Akcje dodatkowe">
                    <foreignObject x="750" y="39" width="400" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" class="iconColors" style="height: 100%; display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
                            <svg width="19" height="19" style="fill: currentColor; flex-shrink: 0;">
                                <use xlink:href="#file-invoice-dollar"></use>
                            </svg>
                            <span style="font-size: 14px; font-weight: 600; text-align: right; line-height: 1.2;">TRANSLATION_Prv_Cart_ChangeInInquiry</span>
                        </div>
                    </foreignObject>
                    <foreignObject x="1172" y="39" width="250" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" class="iconColors" style="height: 100%; display: flex; align-items: center; justify-content: flex-start; gap: 8px;">
                            <svg width="19" height="19" style="fill: currentColor; flex-shrink: 0;">
                                <use xlink:href="#trash-alt"></use>
                            </svg>
                            <span style="font-size: 14px; font-weight: 600; text-align: left; line-height: 1.2;">TRANSLATION_Prv_Cart_ClearCart</span>
                        </div>
                    </foreignObject>
                </g>
            </g>
            <g id="Tabela">
                <g id="Frame 508">
                    <g id="Title">
                        <g id="Cells">
                            <g id="Frame 668">
                                <g id="Title_2">
                                    <text id="Nr" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                        <tspan x="146" y="123.091">TRANSLATION_Prv_Cart_Number</tspan>
                                    </text>
                                </g>
                                <g id="Title_3">
                                    <text id="Towar" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                        <tspan x="192" y="123.091">TRANSLATION_Prv_Product</tspan>
                                    </text>
                                </g>
                                <g id="Frame 571">
                                    <g id="Title_4">
                                        <text id="Cena netto" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                            <tspan x="647" y="123.091">TRANSLATION_Prv_Cart_NettoPrice</tspan>
                                        </text>
                                    </g>
                                    <g id="Title_5">
                                        <text id="Cena brutto" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                            <tspan x="778" y="123.091">TRANSLATION_Prv_Cart_BruttoPrice</tspan>
                                        </text>
                                    </g>
                                    <g id="Title_6">
                                        <text id="Ilosc1" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                            <tspan x="882" y="123.091">TRANSLATION_Prv_Quantity</tspan>
                                        </text>
                                    </g>
                                    <g id="Title_7">
                                        <text id="Wartosc_brutto_1" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                            <tspan x="1037" y="123.091">TRANSLATION_Prv_Cart_ValuePrice</tspan>
                                        </text>
                                    </g>
                                    <g id="Title_8">
                                        <text id="Waluta" class="primaryColorFont"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                            <tspan x="1162" y="123.091">TRANSLATION_Prv_Currency</tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                            <g id="Menu">
                                <g id="Navigation/Menu vertical" transform="translate(1262.000000, 105.500000)">
                                    <use class="primaryColor" xlink:href="#ellipsis-v" width="19" height="25"></use>
                                </g>
                            </g>
                        </g>
                    </g>
                    <line id="Divider" x1="130" y1="139.5" x2="1310" y2="139.5" stroke="#E7E7E7"/>
                    <g id="Frame 583">
                        <g id="Row">
                            <g id="Cells_2">
                                <g id="Frame 575">
                                    <text id="233" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="146" y="175.091">1</tspan>
                                    </text>
                                    <image id="Rectangle 184" x="192" y="150" width="40" height="40" href="./img/previewElements/cartItem1.png" />
                                    <g id="Frame 574">
                                        <text id="Czerwone krzes&#197;&#130;o komfort 500" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                            <tspan x="248" y="165.091">QuantumCore Ultra X9 Pro</tspan>
                                        </text>
                                        <foreignObject x="248" y="174" width="350" height="20">
                                            <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                                <span>TRANSLATION_Prv_Cart_Spec_EightCores</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_SixteenThreads</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_TurboBoostFiveGHz</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>3.8 GHz</span>
                                            </div>
                                        </foreignObject>
                                    </g>
                                </g>
                                <g id="Frame 572">
                                    <g id="Frame 940" transform="translate(-146.000000, 0)">
                                        <text id="99 999,99" class="primaryColorFont" font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan text-anchor="end" x="858.436" y="175.091">3 299,89</tspan>
                                        </text>
                                    </g>
                                    <text id="99 999,99_2" transform="translate(-132.000000, 0)" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="980.436" y="175.091">4 058,86</tspan>
                                    </text>
                                    <g id="Frame 585">
                                        <g id="Amount WCAG">
                                            <rect x="882.5" y="150.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                            <rect x="882.5" y="150.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                            <g id="Icon" transform="translate(893.000000, 162.000000)">
                                                <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                            </g>
                                            <text id="9999" transform="translate(-77, 0)" class="primaryColorFont" text-anchor="middle"   font-family="Inter" font-size="14" letter-spacing="0px">
                                                <tspan x="1004.633" y="175.091">9</tspan>
                                            </text>
                                            <g id="Icon_2" transform="translate(952.000000, 162.000000)">
                                                <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                            </g>
                                        </g>
                                        <foreignObject x="975" y="162" width="50" height="24">
                                            <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                        </foreignObject>
                                    </g>
                                    <text id="99 999,99_3"  transform="translate(-132.000000, 0)"  class="primaryColorFont" font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="1258.44" y="175.091">36 529,74</tspan>
                                    </text>
                                    <text id="z&#197;&#130;" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="1162" y="175.091">z&#x142;</tspan>
                                    </text>
                                </g>
                                <g id="arrow">
                                    <g id="Arrows/chevron down" transform="translate(1220.000000, 162.000000)">
                                        <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                    </g>
                                </g>
                                <g id="delete">
                                    <g id="Navigation/Delete_2" transform="translate(1262.000000, 160.000000)">
                                        <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                    </g>
                                </g>
                            </g>
                            <line id="Divider_2" x1="130" y1="199.5" x2="1310" y2="199.5" stroke="#E7E7E7"/>
                        </g>
                        <g id="Row_2">
                            <g id="Cells_3">
                                <g id="Frame 575_2">
                                    <text id="233_2" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="146" y="235.091">2</tspan>
                                    </text>
                                    <image id="Rectangle 184_3" x="192" y="210" width="40" height="40" href="./img/previewElements/cartItem2.png" />
                                    <g id="Frame 574_2">
                                        <text id="Czerwone krzes&#197;&#130;o komfort 500_2" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                            <tspan x="248" y="225.091">HyperThread Advanced A12 Extreme</tspan>
                                        </text>
                                        <foreignObject x="248" y="234" width="380" height="20">
                                            <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                                <span>TRANSLATION_Prv_Cart_Spec_EightCores</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_TwentyFourThreads</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_TurboBoostFourNineGHz</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>3.6 GHz</span>
                                            </div>
                                        </foreignObject>
                                    </g>
                                </g>
                                <g id="Frame 572_2">
                                    <g id="Frame 940_2" transform="translate(-146.000000, 0)">
                                        <text id="99 999,99_4" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan text-anchor="end" x="858.436" y="235.091">3 999,99</tspan>
                                        </text>
                                    </g>
                                    <text id="99 999,99_5" class="primaryColorFont" transform="translate(-132.000000, 0)" font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="980.436" y="235.091">4 919,99</tspan>
                                    </text>
                                    <g id="Frame 585_2">
                                        <g id="Amount WCAG_2">
                                            <rect x="882.5" y="210.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                            <rect x="882.5" y="210.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                            <g id="Icon_3" transform="translate(893.000000, 222.000000)">
                                                <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                            </g>
                                            <text id="9999_2" class="primaryColorFont" text-anchor="middle" transform="translate(-77, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                                <tspan x="1004.633" y="235.091">7</tspan>
                                            </text>
                                            <g id="Icon_4" transform="translate(952.000000, 222.000000)">
                                                <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                            </g>
                                        </g>
                                        <foreignObject x="976" y="221" width="40" height="24">
                                            <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                        </foreignObject>
                                    </g>
                                    <text id="99 999,99_6" class="primaryColorFont" transform="translate(-132.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="1258.44" y="235.091">34 439,93</tspan>
                                    </text>
                                    <text id="z&#197;&#130;_2" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="1162" y="235.091">z&#x142;</tspan>
                                    </text>
                                </g>
                                <g id="arrow_2">
                                    <g id="Arrows/chevron down_2" transform="translate(1220.000000, 222.000000)">
                                        <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                    </g>
                                </g>
                                <g id="delete_2">
                                    <g id="Navigation/Delete_3" transform="translate(1262.000000, 220.000000)">
                                        <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                    </g>
                                </g>
                            </g>
                            <line id="Divider_3" x1="130" y1="259.5" x2="1310" y2="259.5" stroke="#E7E7E7"/>
                        </g>
                        <g id="Row_3">
                            <g id="Cells_4">
                                <g id="Frame 575_3">
                                    <text id="233_3" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="146" y="295.091">3</tspan>
                                    </text>
                                    <image id="Rectangle 184_5" x="192" y="270" width="40" height="40" href="./img/previewElements/cartItem3.png" />
                                    <g id="Frame 574_3">
                                        <text id="Czerwone krzes&#197;&#130;o komfort 500_3" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                            <tspan x="248" y="285.091">QuantumCore FORTE 230V biały GNS-223-BIAGNS-223...</tspan>
                                        </text>
                                        <foreignObject x="248" y="294" width="380" height="20">
                                            <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                                <span>TRANSLATION_Prv_Cart_Spec_TwentyCores</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_TwentyFourThreads</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>TRANSLATION_Prv_Cart_Spec_TurboBoostFourNineGHz</span>
                                                <span style="color: #E8E8E8;">|</span>
                                                <span>4.0 GHz</span>
                                            </div>
                                        </foreignObject>
                                    </g>
                            </g>
                            <g id="Frame 572_3">
                                <g id="Frame 940_3" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_7" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="295.091">3 799,00</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_8" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="295.091">4 672,77</tspan>
                                </text>
                                <g id="Frame 585_3">
                                    <g id="Amount WCAG_3">
                                        <rect x="882.5" y="270.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="270.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_5" transform="translate(893.000000, 282.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_3" class="primaryColorFont" transform="translate(-72, 0)" text-anchor="middle" transform="translate(-77, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="295.091">6</tspan>
                                        </text>
                                        <g id="Icon_6" transform="translate(952.000000, 282.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="281" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_9" class="primaryColorFont"  transform="translate(-120.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="295.091">28 036,62</tspan>
                                </text>
                                <text id="z&#197;&#130;_3" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="295.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_3">
                                <g id="Arrows/chevron down_3" transform="translate(1220.000000, 282.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_3">
                                <g id="Navigation/Delete_4" transform="translate(1262.000000, 280.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_4" x1="130" y1="319.5" x2="1310" y2="319.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_4">
                        <g id="Cells_5">
                            <g id="Frame 575_4">
                                <text id="233_4" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="355.091">4</tspan>
                                </text>
                                <image id="Rectangle 184_7" x="192" y="330" width="40" height="40" href="./img/previewElements/cartItem4.png" />
                                <g id="Frame 574_4">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_4" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="345.091">TRANSLATION_Prv_Cart_ProductRAM</tspan>
                                    </text>
                                    <foreignObject x="248" y="354" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>12 GB GDDR6</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>PCIe 4.0</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>HDMI 2.1</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>3x DisplayPort</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_4">
                                <g id="Frame 940_4" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_10" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="355.091">5 499,90</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_11" class="primaryColorFont"  transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="355.091">6 764,88</tspan>
                                </text>
                                <g id="Frame 585_4">
                                    <g id="Amount WCAG_4">
                                        <rect x="882.5" y="330.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="330.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_7" transform="translate(893.000000, 342.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_4" class="primaryColorFont" text-anchor="middle" transform="translate(-72, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="355.091">2</tspan>
                                        </text>
                                        <g id="Icon_8" transform="translate(952.000000, 342.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="341" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_12" class="primaryColorFont" transform="translate(-120.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="355.091">13 529,76</tspan>
                                </text>
                                <text id="z&#197;&#130;_4" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="355.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_4">
                                <g id="Arrows/chevron down_4" transform="translate(1220.000000, 342.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_4">
                                <g id="Navigation/Delete_5" transform="translate(1262.000000, 340.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_5" x1="130" y1="379.5" x2="1310" y2="379.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_5">
                        <g id="Cells_6">
                            <g id="Frame 575_5">
                                <text id="233_5" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="415.091">5</tspan>
                                </text>
                                <image id="Rectangle 184_9" x="192" y="390" width="40" height="40" href="./img/previewElements/cartItem5.png" />
                                <g id="Frame 574_5">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_5" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="405.091">TRANSLATION_Prv_Cart_ProductLaptop</tspan>
                                    </text>
                                    <foreignObject x="248" y="414" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>15.6" Full HD</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>Intel Core i7-12700H</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>RAM 16 GB DDR5</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_5">
                                <g id="Frame 940_5" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_13" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="415.091">6 599,99</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_14" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="415.091">8 117,98</tspan>
                                </text>
                                <g id="Frame 585_5">
                                    <g id="Amount WCAG_5">
                                        <rect x="882.5" y="390.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="390.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_9" transform="translate(893.000000, 402.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_5" class="primaryColorFont" text-anchor="middle"  transform="translate(-72, 0)" font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="415.091">3</tspan>
                                        </text>
                                        <g id="Icon_10" transform="translate(952.000000, 402.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="401" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_15" class="primaryColorFont" transform="translate(-120.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="415.091">24 353,96</tspan>
                                </text>
                                <text id="z&#197;&#130;_5" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="415.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_5">
                                <g id="Arrows/chevron down_5" transform="translate(1220.000000, 402.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_5">
                                <g id="Navigation/Delete_6" transform="translate(1262.000000, 400.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_6" x1="130" y1="439.5" x2="1310" y2="439.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_6">
                        <g id="Cells_7">
                            <g id="Frame 575_6">
                                <text id="233_6" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="475.091">6</tspan>
                                </text>
                                <image id="Rectangle 184_11" x="192" y="450" width="40" height="40" href="./img/previewElements/cartItem6.png" />
                                <g id="Frame 574_6">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_6" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="465.091">TRANSLATION_Prv_Cart_ProductKeyboard</tspan>
                                    </text>
                                    <foreignObject x="248" y="474" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>TRANSLATION_Prv_Cart_Spec_Mechanical</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_RGBBacklight</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_USBPassthrough</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_6">
                                <g id="Frame 940_6" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_16" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="475.091">749,00</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_17" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="475.091">921,27</tspan>
                                </text>
                                <g id="Frame 585_6">
                                    <g id="Amount WCAG_6">
                                        <rect x="882.5" y="450.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="450.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_11" transform="translate(893.000000, 462.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_6" class="primaryColorFont" text-anchor="middle" transform="translate(-72, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="475.091">8</tspan>
                                        </text>
                                        <g id="Icon_12" transform="translate(952.000000, 462.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="461" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_18" class="primaryColorFont"  transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="475.091">7 370,16</tspan>
                                </text>
                                <text id="z&#197;&#130;_6" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="475.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_6">
                                <g id="Arrows/chevron down_6" transform="translate(1220.000000, 462.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_6">
                                <g id="Navigation/Delete_7" transform="translate(1262.000000, 460.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_7" x1="130" y1="499.5" x2="1310" y2="499.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_7">
                        <g id="Cells_8">
                            <g id="Frame 575_7">
                                <text id="233_7" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="535.091">7</tspan>
                                </text>
                                <image id="Rectangle 184_13" x="192" y="510" width="40" height="40" href="./img/previewElements/cartItem7.png" />
                                <g id="Frame 574_7">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_7" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="525.091">TRANSLATION_Prv_Cart_ProductMouse</tspan>
                                    </text>
                                    <foreignObject x="248" y="534" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>TRANSLATION_Prv_Cart_Spec_OpticalDPI</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_RazerChromaRGB</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_WeightEightyFiveG</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_7">
                                <g id="Frame 940_7" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_19" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="535.091">329,00</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_20" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="535.091">404,67</tspan>
                                </text>
                                <g id="Frame 585_7">
                                    <g id="Amount WCAG_7">
                                        <rect x="882.5" y="510.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="510.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_13" transform="translate(893.000000, 522.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_7" class="primaryColorFont" text-anchor="middle" transform="translate(-72, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="535.091">12</tspan>
                                        </text>
                                        <g id="Icon_14" transform="translate(952.000000, 522.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="521" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_21" class="primaryColorFont" transform="translate(-120.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="535.091">4 856,04</tspan>
                                </text>
                                <text id="z&#197;&#130;_7" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="535.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_7">
                                <g id="Arrows/chevron down_7" transform="translate(1220.000000, 522.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_7">
                                <g id="Navigation/Delete_8" transform="translate(1262.000000, 520.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_8" x1="130" y1="559.5" x2="1310" y2="559.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_8">
                        <g id="Cells_9">
                            <g id="Frame 575_8">
                                <text id="233_8" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="595.091">8</tspan>
                                </text>
                                <image id="Rectangle 184_15" x="192" y="570" width="40" height="40" href="./img/previewElements/cartItem8.png" />
                                <g id="Frame 574_8">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_8" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="585.091">TRANSLATION_Prv_Cart_ProductMonitor</tspan>
                                    </text>
                                    <foreignObject x="248" y="594" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>2560x1440 (QHD)</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>165 Hz</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_MatrixTypeIPS</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_8">
                                <g id="Frame 940_8" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_22" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="595.091">1 699,90</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_23" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="595.091">2 090,88</tspan>
                                </text>
                                <g id="Frame 585_8">
                                    <g id="Amount WCAG_8">
                                        <rect x="882.5" y="570.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="570.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_15" transform="translate(893.000000, 582.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_8" class="primaryColorFont" text-anchor="middle" transform="translate(-72, 0)" font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="595.091">4</tspan>
                                        </text>
                                        <g id="Icon_16" transform="translate(952.000000, 582.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="581" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_24" class="primaryColorFont"  transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="595.091">8 363,52</tspan>
                                </text>
                                <text id="z&#197;&#130;_8" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="595.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_8">
                                <g id="Arrows/chevron down_8" transform="translate(1220.000000, 582.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_8">
                                <g id="Navigation/Delete_9" transform="translate(1262.000000, 580.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_9" x1="130" y1="619.5" x2="1310" y2="619.5" stroke="#E7E7E7"/>
                    </g>
                    <g id="Row_9">
                        <g id="Cells_10">
                            <g id="Frame 575_9">
                                <text id="233_9" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="146" y="655.091">9</tspan>
                                </text>
                                <image id="Rectangle 184_17" x="192" y="630" width="40" height="40" href="./img/previewElements/cartItem9.png" />
                                <g id="Frame 574_9">
                                    <text id="Czerwone krzes&#197;&#130;o komfort 500_9" class="primaryColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                                        <tspan x="248" y="645.091">TRANSLATION_Prv_Cart_ProductHDD</tspan>
                                    </text>
                                    <foreignObject x="248" y="654" width="380" height="20">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                            <span>1 TB</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_InterfacePCIe</span>
                                            <span style="color: #E8E8E8;">|</span>
                                            <span>TRANSLATION_Prv_Cart_Spec_ReadSpeed</span>
                                        </div>
                                    </foreignObject>
                                </g>
                            </g>
                            <g id="Frame 572_9">
                                <g id="Frame 940_9" transform="translate(-132.000000, 0)">
                                    <text id="99 999,99_25" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan text-anchor="end" x="846.436" y="655.091">599,99</tspan>
                                    </text>
                                </g>
                                <text id="99 999,99_26" class="primaryColorFont" transform="translate(-120.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="968.436" y="655.091">737,99</tspan>
                                </text>
                                <g id="Frame 585_9">
                                    <g id="Amount WCAG_9">
                                        <rect x="882.5" y="630.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                        <rect x="882.5" y="630.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                        <g id="Icon_17" transform="translate(893.000000, 642.000000)">
                                            <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                        </g>
                                        <text id="9999_9" class="primaryColorFont" text-anchor="middle" transform="translate(-72, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                            <tspan x="998.633" y="655.091">10</tspan>
                                        </text>
                                        <g id="Icon_18" transform="translate(952.000000, 642.000000)">
                                            <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>    
                                        </g>
                                    </g>
                                    <foreignObject x="976" y="641" width="40" height="24">
                                        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 14px;">TRANSLATION_Prv_Cart_Pcs</div>
                                    </foreignObject>
                                </g>
                                <text id="99 999,99_27" class="primaryColorFont" transform="translate(-120.000000, 0)"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan text-anchor="end" x="1246.44" y="655.091">7 379,88</tspan>
                                </text>
                                <text id="z&#197;&#130;_9" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="1162" y="655.091">z&#x142;</tspan>
                                </text>
                            </g>
                            <g id="arrow_9">
                                <g id="Arrows/chevron down_9" transform="translate(1220.000000, 642.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#chevron-down" width="16" height="16"></use>
                                </g>
                            </g>
                            <g id="delete_9">
                                <g id="Navigation/Delete_10" transform="translate(1262.000000, 640.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <line id="Divider_10" x1="130" y1="679.5" x2="1310" y2="679.5" stroke="#E7E7E7"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
    <g id="Podsumowanie">
        <!--
        <g id="Punkty">
            <rect x="130" y="760" width="478" height="184" rx="12" fill="#F8F9FA"/>
            <g id="Frame 805">
                <g id="Interface/Award" transform="translate(162.000000, 830.000000)">
                    <use fill="#2E2E2E" xlink:href="#award" width="48" height="48"></use>
                </g>
                <g id="Frame 806">
                    <g id="Frame 807">
                        <g id="Za to zam&#195;&#179;wienie otrzymasz 862 punkty.">
                            <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan x="226" y="833.091">TRANSLATION_Prv_Cart_LoyaltyFirstText</tspan>
                            </text>
                        </g>
                    </g>
                    <g id="Towary: +10 pkt">
                        <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                            <tspan x="226" y="857.091">TRANSLATION_Prv_Cart_LoyaltySecondText</tspan>
                        </text>
                    </g>
                    <g id="Warto&#197;&#155;&#196;&#135; zam&#195;&#179;wienia: +852 pkt">
                        <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                            <tspan x="226" y="881.091">TRANSLATION_Prv_Cart_LoyaltyThirdText</tspan>
                        </text>
                    </g>
                </g>
            </g>
        </g>
        -->
        <g id="Podsumowanie kwota">
            <g id="Tytu&#197;&#130;">
                <g id="Frame 891">
                    <text id="Metoda dostawy" class="primaryColorFont"   font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                        <tspan x="832.44" y="778.545">TRANSLATION_Prv_Cart_Summary</tspan>
                    </text>
                </g>
            </g>
            <g id="Frame 584">
                <g id="Frame 567">
                    <text id="Warto&#197;&#155;&#196;&#135; VAT:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan x="832" y="815.091">TRANSLATION_Prv_Cart_VatValue:</tspan>
                    </text>
                    <text id="536,00 z&#197;&#130;" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan text-anchor="end" x="1371" y="815.091">30 827,40 z&#x142;</tspan>
                    </text>
                </g>
                <g id="Frame 565">
                    <text id="Warto&#197;&#155;&#196;&#135; netto:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan x="832" y="843.091">TRANSLATION_Prv_Cart_NettoValuePrice:</tspan>
                    </text>
                    <text id="2 330,44 z&#197;&#130;" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan text-anchor="end" x="1371" y="843.091">134 032,21 z&#x142;</tspan>
                    </text>
                </g>
                <g id="Frame 566">
                    <text id="Warto&#197;&#155;&#196;&#135; brutto:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan x="832" y="871.091">TRANSLATION_Prv_Cart_ValuePrice:</tspan>
                    </text>
                    <text id="2 866,44 z&#197;&#130;" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                        <tspan text-anchor="end" x="1371" y="871.091">164 859,61 z&#x142;</tspan>
                    </text>
                </g>
            </g>
            <g id="Frame 562">
                <text id="Do zap&#197;&#130;aty:" class="primaryColorFont"   font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                    <tspan x="832" y="938.545">TRANSLATION_Prv_Cart_ToPay:</tspan>
                </text>
                <text id="999 999,99 z&#197;&#130;" class="primaryColorFont"   font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                    <tspan text-anchor="end" x="1372" y="938.545">164 859,61 z&#x142;</tspan>
                </text>
            </g>
        </g>
    </g>
    <g id="Buttony">
        <g id="4. Text Button_5">
            <g id="Arrows/chevron left_2" transform="translate(134.000000, 988.000000)">
                <use class="btnSolidBgColor" xlink:href="#chevron-left" width="16" height="16"></use>
            </g>
            <text id="Text_5" class="btnSolidBgColor"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                <tspan x="158.057" y="1001.09">TRANSLATION_Prv_BackToShopping</tspan>
            </text>
        </g>
        <g id="Frame 898">
            <g id="Primary button">
                <rect transform="translate(25 0)" x="931" y="976" width="280" height="40" rx="5" class="btnSolidBgColor"/>
                <text id="Button" class="btnSolidTextColor" transform="translate(-4 0)" text-anchor="middle" font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                    <tspan x="1098.72" y="1001.09">TRANSLATION_Prv_Cart_GoToCart</tspan>
                </text>
            </g>
        </g>
    </g>
</g>`;